import {
  PAGE_NOT_FOUND,
  CONTATTI,
  FAQ,
  INFORMATIVA_TRATTAMENTO_DATI,
  LINGUA_ITALIANA,
  NESSUN_OSPEDALE_TITLE,
  NESSUN_OSPEDALE_MESSAGE,
  INSTALLAZIONE_HEADER,
  INSTALLAZIONE_ISTRUZIONI1,
  INSTALLAZIONE_ISTRUZIONI2,
  INSTALLAZIONE_ISTRUZIONI3,
  INSTALLAZIONE_ISTRUZIONI4,
  EMPTY_MESSAGE,
  SELECT_PLACEHOLDER,
  INPUT_PLACEHOLDER,
  AZIENDA_SANITARIA_LABEL,
  AZIENDA_SANITARIA_MESSAGE,
  AZIENDA_SANITARIA_PLACEHOLDER,
  STRUTTURA_SANITARIA_LABEL,
  STRUTTURA_SANITARIA_MESSAGE,
  STRUTTURA_SANITARIA_PLACEHOLDER,
  ID_PAZIENTE_LABEL,
  ID_PAZIENTE_MESSAGE,
  ID_PAZIENTE_PLACEHOLDER,
  ACCEDI,
  RESET,
  ACQUISIZIONE_FOTOCAMERA,
  SPINNING_INTERVENTO,
  QR_CODE_ERRATO_TITLE,
  QR_CODE_ERRATO_MESSAGE,
  INTERVENTO_204_TITLE,
  INTERVENTO_204_MESSAGE,
  LEGENDA,
  NON_INIZIATO_LABEL,
  IN_CORSO_LABEL,
  CONCLUSO_LABEL,
  ID_PAZIENTE_TITLE,
  DATA_INTERVENTO_TITLE,
  STATO_NON_DISPONIBILE,
  STATO_INTERVENTO_PIANIFICATO,
  STATO_IN_BLOCCO_OPERATORIO,
  STATO_INTERVENTO_IN_CORSO,
  STATO_INTERVENTO_POST_OPERATORIO,
  STATO_INTERVENTO_TERMINATO,
  INGRESSO_BLOCCO_OPERATORIO_LABEL,
  INGRESSO_SALA_OPERATORIA_LABEL,
  USCITA_SALA_OPERATORIA_LABEL,
  USCITA_BLOCCO_OPERATORIO_LABEL,
  LAST_UPDATE_LABEL,
  INTERVENTO_NUOVI_DATI_TITLE,
  INTERVENTO_NUOVI_DATI_MESSAGE,
  SERVIZIO_NON_DISPONIBILE_TITLE,
  SERVIZIO_NON_DISPONIBILE_MESSAGE,
} from "../modules/language";

const common = {
  [PAGE_NOT_FOUND]: "Page not found!",
  [CONTATTI]: "Contacts",
  [FAQ]: "FAQ",
  [INFORMATIVA_TRATTAMENTO_DATI]: "Information on data processing",
  [LINGUA_ITALIANA]: "Italiano",
};

const notification = {
  [NESSUN_OSPEDALE_TITLE]: "No Health/Hospital centre found",
  [NESSUN_OSPEDALE_MESSAGE]: "An error occurred during the retrieval of Health/Hospital Centres",
};

const installazioneApple = {
  [INSTALLAZIONE_HEADER]: "Installation",
  [INSTALLAZIONE_ISTRUZIONI1]: "Tap",
  [INSTALLAZIONE_ISTRUZIONI2]: "and then",
  [INSTALLAZIONE_ISTRUZIONI3]: "'Add to Home'",
  [INSTALLAZIONE_ISTRUZIONI4]: "to install the App on your device",
};

const formRicerca = {
  [EMPTY_MESSAGE]: "No results",
  [SELECT_PLACEHOLDER]: "Select...",
  [INPUT_PLACEHOLDER]: "Enter...",
  [AZIENDA_SANITARIA_LABEL]: "Select the Health/Hospital Centre",
  [AZIENDA_SANITARIA_MESSAGE]: "Select the health centre!",
  [AZIENDA_SANITARIA_PLACEHOLDER]: "Health/Hospital centre",
  [STRUTTURA_SANITARIA_LABEL]: "Select the Facility",
  [STRUTTURA_SANITARIA_MESSAGE]: "Select the facility!",
  [STRUTTURA_SANITARIA_PLACEHOLDER]: "Facility",
  [ID_PAZIENTE_LABEL]: "Enter the received identification code:",
  [ID_PAZIENTE_MESSAGE]: "Enter the identification code!",
  [ID_PAZIENTE_PLACEHOLDER]: "Identification code received",
  [ACCEDI]: "Continue",
  [RESET]: "Clean the data",
  [ACQUISIZIONE_FOTOCAMERA]: "Acquire from camera",
  [SPINNING_INTERVENTO]: "Information retrieval for the indicated patient",
  [QR_CODE_ERRATO_TITLE]: "Invalid QR Code",
  [QR_CODE_ERRATO_MESSAGE]: "The information could not be retrieved from the scanned qr code",
  [INTERVENTO_204_TITLE]: "No information available",
  [INTERVENTO_204_MESSAGE]: "No information is displayed for the selected facility and the entered identification code", //prettier-ignore
  [INTERVENTO_NUOVI_DATI_TITLE]: "New update",
  [INTERVENTO_NUOVI_DATI_MESSAGE]: "The information in the system highlights a new update",
  [SERVIZIO_NON_DISPONIBILE_TITLE]: "Service temporarily unavailable",
  [SERVIZIO_NON_DISPONIBILE_MESSAGE]: "Try again in a few minutes",
};

const monitora = {
  [LEGENDA]: "Key",
  [NON_INIZIATO_LABEL]: "non yet started",
  [IN_CORSO_LABEL]: "in progress",
  [CONCLUSO_LABEL]: "finished",
  [ID_PAZIENTE_TITLE]: "Patient ID",
  [DATA_INTERVENTO_TITLE]: "Surgery date",
  [STATO_NON_DISPONIBILE]: "Information unavailable",
  [STATO_INTERVENTO_PIANIFICATO]: "Surgery planned for ",
  [STATO_IN_BLOCCO_OPERATORIO]: "Into surgical unit",
  [STATO_INTERVENTO_IN_CORSO]: "Surgery in progress",
  [STATO_INTERVENTO_POST_OPERATORIO]: "Post-surgery",
  [STATO_INTERVENTO_TERMINATO]: "Finished surgery",
  [INGRESSO_BLOCCO_OPERATORIO_LABEL]: "Entry into surgical unit",
  [INGRESSO_SALA_OPERATORIA_LABEL]: "Entry into operating theatre",
  [USCITA_SALA_OPERATORIA_LABEL]: "Exit from operating theatre",
  [USCITA_BLOCCO_OPERATORIO_LABEL]: "Exit from surgical unit",
  [LAST_UPDATE_LABEL]: "Last update:",
};

const en = {
  ...common,
  ...notification,
  ...installazioneApple,
  ...formRicerca,
  ...monitora,
};

export { en };
